import { useCallback, useContext, useState } from 'react'
import { MESSAGE_TEMPLATES_QUERY_KEY } from '../components/MessageTemplates'
import { MessageTemplateCtx } from '../providers/MessageTemplate.provider'
import type { DeliveryChannel } from '../providers/MessageTemplate.provider'
import { IMessageTemplateSchema } from '../schemas/message-template.schema'
import type { ErrorToastHandler } from './useError'
import { useError } from './useError'
import { useQueryClientSingleton } from './useQueryClientSingleton'
import { useTranslation } from 'i11n/client'
import {
  buildMessageTemplateDefinition,
  resolveMessageTemplateType,
} from '../constants/message-template'

export const useMessageTemplateCreate = (props: {
  btnLabel?: string
  onErrorToast?: ErrorToastHandler
}) => {
  const t = useTranslation()
  const btnLabel = props.btnLabel || t('Crear plantilla')

  const [createMessageTemplate, setCreateMessageTemplate] =
    useState<DeliveryChannel>()

  const formId = 'create-message-template-form'

  const { postMethod } = useContext(MessageTemplateCtx)!

  const [isLoading, setIsLoading] = useState(false)

  const queryClient = useQueryClientSingleton()

  const error = useError(props.onErrorToast)

  const onCreateMessageTemplate = useCallback(
    (messageTemplate: IMessageTemplateSchema, onSuccess: () => void) => {
      if (!createMessageTemplate) return

      setIsLoading(true)

      postMethod({
        template: buildMessageTemplateDefinition(messageTemplate),
        channel: createMessageTemplate,
        type: resolveMessageTemplateType(messageTemplate.type),
      })
        .then((res) => {
          queryClient.invalidateQueries({
            queryKey: [MESSAGE_TEMPLATES_QUERY_KEY],
          })

          onSuccess()

          setCreateMessageTemplate(undefined)
        })
        .catch(error.handleError)
        .finally(() => setIsLoading(false))
    },
    [createMessageTemplate, error.handleError, postMethod, queryClient],
  )

  return {
    onCreateMessageTemplate,
    createMessageTemplate,
    btnLabel,
    formId,
    isLoading,
    setIsLoading,
    setCreateMessageTemplate,
  }
}
